<template>
    <div class="report__list_grid_item">
        <div class="report__list_grid_item_content">
            <div class="report__list_grid_item_content_top">
                <div class="columns is-vcentered">
                    <div class="column">
                        <h2 class="report__list_grid_item_content_top_title">{{ fromKebabCaseToString(reportTitles) | toCapitalize }}</h2>
                    </div>

                </div>
            </div>
            <div class="report__list_grid_item_content_details">
                <div class="report__list_grid_item_content_details_session">{{ $t('ebs.reports.title.displayOrDownloadCCSV') }} {{ reportSlug }} {{ $t('ebs.reports.title.report') }}</div>
            </div>
            <div class="report__list_grid_item_actions">
                <div class="columns is-variable">
                    <div class="column is-narrow">
                        <component-button
                            :to="{ name: 'ebs-report-show', params: { slug: reportSlug } }"
                            :name="`report-list-grid-item-content-details-${reportTitles}`"
                        >Launch</component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            :theme="'default'"
                            :name="`report-list-grid-item-content-details-${reportTitles}`"
                            :animate-loading="true"
                            :animate-loading-event-name="'generate-csv-report'"
                            @click="generateCSVReport"
                        >Export to CSV</component-button>
                    </div>
                    <div class="column"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import { User } from '@/User'

export default {
  name: 'report-list-grid-item',
  components: { ComponentButton },
  data () {
    return {
      user: new User()
    }
  },
  props: {
    reportSlug: {
      type: String,
      required: true
    },
    reportTitles: {
      type: String,
      required: true
    }
  },
  methods: {
    generateCSVReport () {
      this.$store.dispatch('getReportGeneratedReportCSV', this.reportSlug).finally(() => {
        this.$eventBus.$emit('stop-generate-csv-report')
      })
    }
  }
}
</script>

<style lang="scss">
    @import '~@/assets/scss/components/ebs/reports/reportlistgriditem';
</style>
